import { createContext, useContext } from 'react';

// What the screens may ask of the shell: `collapse()` folds the sidebar into its rail
// (without moving focus), e.g. when a preview opens beside the chat.
export const StudioSidebarContext = createContext(null);
export const useStudioSidebarControl = () => useContext(StudioSidebarContext);
